export default __webpack_public_path__ + "static/media/discovery.366ba4a4.png";